﻿document.addEventListener('acom-track-event', function (event) {

	if (typeof getTealiumEventData === 'function') {

		if (window.utag && utag.link && utag.data) {

			var trackingData = getTealiumEventData(utag.data, event.detail.trackingId, event.detail.trackingData);

			utag.link(trackingData);
		}
	}

});